import React from 'react'

import { Box, SectionContainer } from '@vividseats/vivid-ui-kit'

import BuyMoreEarnMore from './components/buy-more-earn-more'
import FreeToJoin from './components/free-to-join'
import NoExclusions from './components/no-exclusions'
import styles from './styles.module.scss'

const RewardTopContent: React.FC = () => {
    return (
        <SectionContainer className={styles.section}>
            <Box paddingTop={7} desktopPaddingBottom={12}>
                <BuyMoreEarnMore />
                <NoExclusions />
                <FreeToJoin />
            </Box>
        </SectionContainer>
    )
}

export default RewardTopContent
